import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { getDriversList } from '../../state/actions/drivers'
import { IStoreState, IVehicleFilters } from '../../types'
import AssignVehicelOperator from '../../components/vehicles/edit-vehicle/AssignVehicleOperator'
import * as actions from '../../state/actions/vehicles/'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    vehicleId: ownProps.match.params.vehicleId,
    currentOrganizationId: state.organizations.currentOrgId,
    operators: Object.values(state.drivers.items),
    filters: state.vehicles.filters,
    onClose: ownProps.history.goBack
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchOperators: (organizationId: string) => {
      return dispatch(
        getDriversList({
          organizationId,
          skip: 0,
          take: 1000,
          noAssignedVehicle: true
        })
      )
    },
    assignDriver: (vehicleId: string, operatorId: string, params: IVehicleFilters) => {
      return dispatch(actions.assignDriver(vehicleId, operatorId, params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignVehicelOperator)



// WEBPACK FOOTER //
// ./src/containers/vehicles/AssignVehicleOperator.ts